import {HideHook} from "@/PageDescriptors";
import {Permission} from "@/authSchema";
import {EndpointType} from "@/components/EndpointNumber";
import Endpoint from "@/components/breadcrumbs/Endpoint";
import {ContextFilters} from "@/context/AuthProvider";
import {useDomainNameQuery} from "@/hooks";
import {useDomainIDParam} from "@/types";
import {useParams} from "react-router";

export const EndpointBreadcrumb = (type: EndpointType, resourceIdName: string) => () => {
    const params = useParams();
    return <Endpoint id={parseInt(params[resourceIdName])} type={type} domainId={parseInt(params.domainId)} />;
};

/**
 * Returns a [HideHook] that hides a page if the user does not have the given permission
 * in the context of the current domain.
 *
 * @example
 * ```tsx
 * import {Page} from "@/PageDescriptors";
 *
 * // a page that is only visible to users with the "permission" permission
 * // in the current domain this page is accessed in
 * const page: Page = {
 *   path: "my-page",
 *   label: ...,
 *   contentComponent: ...,
 *   hideHook: domainPermissionHideHook("permission"),
 * }
 * ```
 * */
export const domainPermissionHideHook =
    (permission: Permission): HideHook =>
    (auth) => {
        const domainId = useDomainIDParam();
        const {domainName} = useDomainNameQuery(domainId);

        return !auth.hasPermission(permission, ContextFilters.domain(domainName));
    };
